import { useState } from 'react'
import {LuLayoutDashboard} from 'react-icons/lu'
 import { useTranslation } from 'react-i18next'
 import ReportsNavbar from './Reports/ReportsNavbar';
import CardHeadeWithActions from '../components/ui/CardHeadeWithActions';
import OSALLCAT from './OsUnitsSettings/OSUnits';
import { FiSettings } from 'react-icons/fi';
import UnitsNavbar from './OsUnitsSettings/UnitsNavbar';
 

const Settiings = () => {
    const [t,i18n ] = useTranslation('global')
    const isRTL = i18n.dir() === 'rtl';
  
    const [tabActive,setTabActiive] = useState('Units');

    return (
        <div className='p-5 overflow-hidden h-full'>
            <CardHeadeWithActions title={   <div className='flex items-center gap-2'>
      <FiSettings size={18} /> 
      {t('Warehouse_settings.Warehouse Settings')}
     </div>
}>
            </CardHeadeWithActions>
            
            <UnitsNavbar tabActive={tabActive} setTabActiive={setTabActiive}   />

            <div id='tab' className='bg-slate-100  pt-5 rounded-b-lg'>
                <div id='Units'  
                    className={`flex flex-col gap-2 ${tabActive === 'Units' ? 'block' : 'hidden'} `}>
                    <OSALLCAT/>
                </div>
                 {/* <div id='requisition_report'  
                    className={`flex flex-col gap-2 ${tabActive === 'requisition_report' ? 'block' : 'hidden'} `}>
                    <OsRequisitionReportCom/>
                </div>
                <div id='Product_Report'  
                    className={`flex flex-col gap-2 ${tabActive === 'Product_Report' ? 'block' : 'hidden'} `}>
                        <OSProductReport/>
                </div>
                <div id='stocktakings_report'  
                    className={`flex flex-col gap-2 ${tabActive === 'stocktakings_report' ? 'block' : 'hidden'} `}>
                        <Stocktakings_report/>
                </div> 
                <div id='Tags'  
                    className={`flex flex-col gap-2 ${tabActive === 'Tags' ? 'block' : 'hidden'} `}>
                        {/* <ProductsTags/> 
                </div>  */}
            </div>
        </div>
    );
}

 

export default Settiings